// src/hooks/useUpdateUserProfile.ts
import { useState } from 'react';
import { UserProfile } from '../interfaces';
import config from '../config';
import { useSession } from '../contexts/SessionContext';

const useUpdateUserProfile = () => {
  const [error, setError] = useState<string | null>(null);
  const { sessionState } = useSession();

  const updateProfile = async (profileData: UserProfile) => {
    const token = sessionState.account?.token;
    if (!token) {
      setError('toto Login or token is missing');
      return false;
    }

    try {
      const response = await fetch(`${config.centralApiBaseUrl}/account`, {
        method: 'PUT',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(profileData),
      });

      if (!response.ok) {
        throw new Error('Failed to update user profile');
      }

      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      return false;
    }
  };

  return { updateProfile, error };
};

export default useUpdateUserProfile;
